import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SuccessBlue(props: any) {
    return (
        <Svg
            width={96}
            height={96}
            viewBox="0 0 96 96"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                opacity={0.3}
                d="M96 48c0 26.51-21.49 48-48 48S0 74.51 0 48 21.49 0 48 0s48 21.49 48 48z"
                fill={props.color ? props.color :"#1434CB"}
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48.301 87.241c21.5 0 38.93-17.429 38.93-38.928 0-21.5-17.43-38.93-38.93-38.93S9.373 26.814 9.373 48.314 26.802 87.24 48.3 87.24zm-3.464-25.534a3.3 3.3 0 01-4.666 0L29.635 51.172a3.299 3.299 0 114.666-4.666l8.203 8.203 19.8-19.8a3.3 3.3 0 014.665 4.666L44.837 61.707z"
                fill={props.color ? props.color :"#1434CB"}
            />
            <Path
                d="M64.637 37.24L42.504 59.374 31.968 48.837"
                stroke="#fff"
                strokeWidth={6.5981}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Svg>
    )
}

export default SuccessBlue
